import { API_BASE_URL } from '../services/api';

/**
 * WebSocket URL for teacher inbox (Django Channels, not under /api/).
 * Uses the same host/port as the REST API (REACT_APP_API_URL), with ws/wss scheme.
 */
export function getTeacherInboxWebSocketUrl(token) {
  if (!token) {
    return null;
  }
  const raw = (process.env.REACT_APP_API_URL || API_BASE_URL || 'http://localhost:8000').replace(/\/api\/?$/, '');
  try {
    const u = new URL(raw.startsWith('http') ? raw : `http://${raw}`);
    const protocol = u.protocol === 'https:' ? 'wss:' : 'ws:';
    const host = u.host;
    return `${protocol}//${host}/ws/teacher/inbox/?token=${encodeURIComponent(token)}`;
  } catch {
    const protocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//localhost:8000/ws/teacher/inbox/?token=${encodeURIComponent(token)}`;
  }
}
